import React from 'react';
import ProfileLayout from 'components/ProfileLayout';
import { withAuthGuard } from 'components/auth/withAuthGuard';
import MyPhotos from 'components/user/MyPhotos';

const Profil = () => {
    return (
        <ProfileLayout>
            <MyPhotos />
        </ProfileLayout>
    );
};

export default withAuthGuard(Profil);
